import React, { useEffect, useState } from "react"
import { CSS_PROPERTY } from "../../features/Tablet/cssProperties/tablet"

const BASE_STYLE = {
  display: "flex",
  width: "calc(100% - 3rem)",
  fontSize: "5rem",
  margin: "0 0 3rem 0",
  verticalAlign: "center",
  height: "20rem",
  ...CSS_PROPERTY.BORER_PROPERTIES,
  padding: "2rem 2rem",
}
const GridButton: React.FC<{
  children?: React.ReactNode
  onTouchStartEventHandler?: React.TouchEventHandler<HTMLDivElement>
  isSelected?: boolean
  selectedBackGroundColor?: string
  backGroundColor?: string
}> = ({
  children,
  onTouchStartEventHandler,
  isSelected,
  selectedBackGroundColor,
  backGroundColor,
}) => {
  const [style, setStyle] = useState({
    ...BASE_STYLE,
    backgroundColor: isSelected
      ? selectedBackGroundColor ?? CSS_PROPERTY.CARD.SELECT_COLOR
      : "white",
  })

  useEffect(() => {
    setStyle({
      ...BASE_STYLE,
      backgroundColor: isSelected
        ? selectedBackGroundColor ?? CSS_PROPERTY.CARD.SELECT_COLOR
        : backGroundColor ?? "white",
    })
  }, [backGroundColor, isSelected, selectedBackGroundColor])

  return (
    <div onTouchStart={onTouchStartEventHandler} style={style}>
      {children}
    </div>
  )
}

export default GridButton
